var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.listTitle } },
    [
      _c("template", { slot: "pageContent" }, [
        _vm.isSmartphoneOS
          ? _c("div", { attrs: { slot: "fixed" }, slot: "fixed" }, [
              _c(
                "div",
                { staticClass: "w-100" },
                [
                  _vm.serviceId === _vm.services.PAYMENTS && _vm.mode === 2
                    ? _c("cm-messages-filter", {
                        staticClass: "researchfilter position-relative z-10",
                        attrs: {
                          isPayments: "",
                          received: "",
                          filterType: "group",
                          mode: this.mode,
                        },
                        on: {
                          extractCSV: function ($event) {
                            return _vm.extractCSV()
                          },
                          applyFilter: function ($event) {
                            return _vm.applyFilter($event)
                          },
                          refreshInbox: function ($event) {
                            return _vm.refreshInbox()
                          },
                        },
                      })
                    : _c("cm-messages-filter", {
                        staticClass: "researchfilter position-relative z-10",
                        attrs: {
                          isPayments: "",
                          received: "",
                          filterType: "list",
                          mode: this.mode,
                        },
                        on: {
                          extractCSV: function ($event) {
                            return _vm.extractCSV()
                          },
                          applyFilter: function ($event) {
                            return _vm.applyFilter($event)
                          },
                          refreshInbox: function ($event) {
                            return _vm.refreshInbox()
                          },
                        },
                      }),
                ],
                1
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "listPage ml-3 mr-3",
            staticStyle: { "/* overflow": "hidden" },
          },
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { md: "12" } },
                  [
                    _c("div", { staticClass: "requestsList" }, [
                      !_vm.isSmartphoneOS
                        ? _c(
                            "div",
                            [
                              _vm.serviceId === _vm.services.PAYMENTS &&
                              _vm.mode === 2
                                ? _c("cm-messages-filter", {
                                    staticClass:
                                      "researchfilter position-relative z-10",
                                    attrs: {
                                      isPayments: "",
                                      received: "",
                                      filterType: "group",
                                      mode: this.mode,
                                      randomId: _vm.randomId,
                                      propedServiceId: "1",
                                    },
                                    on: {
                                      extractCSV: function ($event) {
                                        return _vm.extractCSV(_vm.inboxMessages)
                                      },
                                      applyFilter: function ($event) {
                                        return _vm.applyFilter($event)
                                      },
                                      refreshInbox: function ($event) {
                                        return _vm.refreshInbox()
                                      },
                                    },
                                  })
                                : _c("cm-messages-filter", {
                                    staticClass:
                                      "researchfilter position-relative z-10",
                                    attrs: {
                                      isPayments: "",
                                      received: "",
                                      filterType: "list",
                                      mode: this.mode,
                                      randomId: _vm.randomId,
                                      propedServiceId: "1",
                                    },
                                    on: {
                                      extractCSV: function ($event) {
                                        return _vm.extractCSV(_vm.inboxMessages)
                                      },
                                      applyFilter: function ($event) {
                                        return _vm.applyFilter($event)
                                      },
                                      refreshInbox: function ($event) {
                                        return _vm.refreshInbox()
                                      },
                                    },
                                  }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _vm.activateSpinner
                      ? _c("spinner")
                      : _c(
                          "div",
                          [
                            _vm.items.length
                              ? _c(
                                  "span",
                                  { staticClass: "font-weight-bold" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("common.results_payments_desc") +
                                          _vm.paginationObject.nbResultsTotal
                                      )
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.mode === 1 && _vm.items.length
                              ? _c("b-table", {
                                  key: _vm.keyTableRTP,
                                  ref: "tableRTP",
                                  staticClass:
                                    "mt-3 table-condensed sm-mt-3 hide-column table-striped",
                                  attrs: {
                                    hover: "",
                                    fixed: "",
                                    responsive: "",
                                    selectable: "",
                                    items: _vm.items,
                                    fields: _vm.fields,
                                    "select-mode": "single",
                                    "empty-text": "Pas de résultats...",
                                  },
                                  on: { "row-selected": _vm.seeDetails },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "cell(amnt)",
                                        fn: function (data) {
                                          return [
                                            data.value.includes("+")
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "cursor text-success font-weight-bold",
                                                  },
                                                  [_vm._v(_vm._s(data.value))]
                                                )
                                              : _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "cursor text-danger font-weight-bold",
                                                  },
                                                  [_vm._v(_vm._s(data.value))]
                                                ),
                                          ]
                                        },
                                      },
                                      {
                                        key: "cell(direction)",
                                        fn: function (data) {
                                          return [
                                            _c(
                                              "div",
                                              { staticClass: "cursor" },
                                              [
                                                data.value === 0
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "direction-received",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "common.rcvd"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    )
                                                  : _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "direction-sent",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t("common.snt")
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                _vm._v(" "),
                                                data.item.exec_date_warning
                                                  ? _c("i", {
                                                      staticClass:
                                                        "fa-duotone fa-warning text-warning",
                                                      attrs: {
                                                        title: _vm.$t(
                                                          "common.exec_date_exprd"
                                                        ),
                                                      },
                                                    })
                                                  : data.item.technicalCode ===
                                                    "2"
                                                  ? _c("i", {
                                                      staticClass:
                                                        "fa fa-xmark color-red",
                                                    })
                                                  : data.item.technicalCode ===
                                                    "3"
                                                  ? _c("i", {
                                                      staticClass:
                                                        "fa-solid fa-plug-circle-xmark redIcon",
                                                    })
                                                  : _vm._e(),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                      {
                                        key: "cell(rsn)",
                                        fn: function (data) {
                                          return [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "cursor text-ellipsis",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    attrs: {
                                                      title: data.value,
                                                    },
                                                  },
                                                  [_vm._v(_vm._s(data.value))]
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                      {
                                        key: "cell(status_label)",
                                        fn: function (data) {
                                          return [
                                            data.item.standard === "2" &&
                                            data.value === "rtp.20"
                                              ? _c(
                                                  "div",
                                                  { staticClass: "cursor" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "common.status.rtp.10"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _c(
                                                  "div",
                                                  { staticClass: "cursor" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "common.status." +
                                                            data.value
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                          ]
                                        },
                                      },
                                      {
                                        key: "cell(debtor_name)",
                                        fn: function (data) {
                                          return [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "cursor text-ellipsis",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    attrs: {
                                                      title: data.value,
                                                    },
                                                  },
                                                  [_vm._v(_vm._s(data.value))]
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                      {
                                        key: "cell(debtor_iban)",
                                        fn: function (data) {
                                          return [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "cursor text-ellipsis",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    attrs: {
                                                      title: data.value,
                                                    },
                                                  },
                                                  [_vm._v(_vm._s(data.value))]
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                      {
                                        key: "cell(create_date)",
                                        fn: function (data) {
                                          return [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "cursor text-ellipsis",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("formatDateTime")(
                                                      data.value
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                      {
                                        key: "cell(exp_date)",
                                        fn: function (data) {
                                          return [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "cursor text-ellipsis",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("formatDateTime")(
                                                      data.value
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    2969300403
                                  ),
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            true /*mode === 2 && items_grp.length*/
                              ? _c("b-table", {
                                  key: _vm.keyTableGroupRTP,
                                  staticClass: "mt-3 sm-mt-3",
                                  attrs: {
                                    hover: "",
                                    fixed: "",
                                    responsive: "",
                                    items: _vm.items_grp,
                                    fields: _vm.fields_grp,
                                    selectable: "",
                                    "select-mode": "single",
                                  },
                                  on: { "row-selected": _vm.seeDetails_grp },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.items.length <= 0
                              ? _c(
                                  "label",
                                  {
                                    staticClass:
                                      "font-bold w-100 d-flex justify-content-center mt-3",
                                  },
                                  [_vm._v(_vm._s(_vm.$t("common.no_result")))]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      { staticClass: "mt-5" },
                      [
                        _c(
                          "b-col",
                          [
                            _c(
                              "b-col",
                              { attrs: { cols: "12" } },
                              [
                                _c("cm-pagination", {
                                  attrs: {
                                    maxResultsByPage:
                                      _vm.paginationObject.maxResults,
                                    firstIndex: _vm.paginationObject.firstIndex,
                                    nbResultsTotal:
                                      _vm.paginationObject.nbResultsTotal,
                                    refreshEvent: _vm.paginationObject.refresh,
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }